<template>
    <div class="value_with_select-container">
        <div class="custom-select">
            <div class="selected_item">
                <span class="value" v-html="getActive"/>
                <span class="icon-bottom_arrow"/>
            </div>
            <div class="items-container">
                <div class="item"
                     v-for="element in initialData"
                     @click="selectValue(element.id)">
                    <span v-html="element.value"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // NVS-152
    export default {
        name: "corrosion_protection_editable_property_value",
        props: ['initialData', 'defaultKey', 'elementKey', 'connectedKey', 'selectedKey'],
        data() {
            return {
                value: this.selectedKey || this.defaultKey,
                inited: false
            }
        },
        methods: {
            selectValue(id) {
                this.value = id
                this.$store.commit({
                    type: 'selectElementOfCorrosionProtectionValues',
                    valueId: id,
                    elementKey: this.elementKey,
                    connectedKey: this.connectedKey,
                    connectedValue: this.connectedValue,
                    surcharge: this.surcharge
                });
                this.$parent.$emit('updatePrice', true);
            },
            toggleExpandOfCustomSelect(e) {
                let target = e.target;

                document.querySelectorAll('.custom-select').forEach((select) => {

                    select.classList.remove("expanded");
                });

                while (target instanceof Element) {

                    if (target.classList.contains('selected_item')) {

                        target.parentElement.classList.toggle("expanded");
                        return;

                    } else if (
                        target.classList.contains('value') ||
                        target.classList.contains('icon-bottom_arrow')) {

                        if(target.parentElement && target.parentElement.parentElement) target.parentElement.parentElement.classList.toggle("expanded");
                        return;

                    } else if (target.classList.contains('items-container')) {

                        target.parentElement.classList.remove("expanded");
                        return;

                    } else if (target.classList.contains('item')) {

                        target.parentElement.parentElement.classList.remove("expanded");
                        return;

                    } else {
                        return;
                    }
                }
            },
            getCustomAntiCorrosion() {
                return this.$store.state.productCard['custom'].corrosion_protection.values
            }
        },
        computed: {
            getActive() {
                const elem = this.initialData.find(el => el.id == this.value)
                if(elem) return elem.value
                return this.initialData.find(el => el.id == this.defaultKey)
            },
            connectedValue() {
                const elem = this.initialData.find(el => el.id == this.value)
                if(elem) return elem.connectedValue
            },
            surcharge() {
                const elem = this.initialData.find(el => el.id == this.value)
                if(elem) return elem.surcharge
            }
        },

        mounted() {
            // setTimeout(() => {
            //     this.selectValue(this.value);
            // }, 100)
            document.addEventListener("click", this.toggleExpandOfCustomSelect);
        },
        beforeDestroy() {
            document.removeEventListener("click", this.toggleExpandOfCustomSelect);
        },
    }
</script>